import { literalValues } from "@shared/validation/literal-values";

export const WARP_MODE = {
  DISABLED: "disabled",
  STAGING: "staging",
  LIVE: "live",
} as const;

export const WARP_ENVIRONMENT = {
  STAGING: "staging",
  LIVE: "live",
} as const;

export const WARP_ENVIRONMENTS = literalValues(WARP_ENVIRONMENT);

export type WarpEnvironment = (typeof WARP_ENVIRONMENTS)[number];

export const WARP_SHIPMENT_TYPE = {
  LTL: "LTL",
  FTL: "FTL",
} as const;

export const WARP_VEHICLE = {
  CARGO_VAN: "CARGO_VAN",
  BOX_TRUCK_26: "STRAIGHT_TRUCK_26",
  DRY_VAN_53: "DRY_VAN_53",
} as const;

export const WARP_PICKUP_SERVICE = {
  LIFTGATE: "liftgate-pickup",
  RESIDENTIAL: "residential-pickup",
  APPOINTMENT: "pickup-appointment",
  INSIDE: "inside-pickup",
  LIMITED_ACCESS: "limited-access-pickup",
  CONSTRUCTION_SITE: "construction-site-pickup",
  TRADE_SHOW: "convention-trade-show-pickup",
  INSIDE_UPSTAIRS: "inside-pickup-upstairs-mezzanine-trash-removal",
  INSIDE_BACK_OF_HOUSE: "inside-pickup-back-side-of-the-house",
  INSIDE_LIVING_SPACE: "inside-pickup-living-space-garage",
  DRIVER_ASSIST: "driver-assist-pickup",
  DROP_AND_HOOK: "drop-and-hook-pickup",
} as const;

export const WARP_DELIVERY_SERVICE = {
  LIFTGATE: "liftgate-delivery",
  RESIDENTIAL: "residential-delivery",
  APPOINTMENT: "delivery-appointment",
  INSIDE: "inside-delivery",
  LIMITED_ACCESS: "limited-access-delivery",
  CONSTRUCTION_SITE: "construction-site-delivery",
  TRADE_SHOW: "convention-trade-show-delivery",
  INSIDE_UPSTAIRS: "inside-delivery-upstairs-mezzanine-trash-removal",
  INSIDE_BACK_OF_HOUSE: "inside-delivery-back-side-of-the-house",
  INSIDE_LIVING_SPACE: "inside-delivery-living-space-garage",
  DRIVER_ASSIST: "driver-assist-delivery",
  DROP_AND_HOOK: "drop-and-hook-delivery",
  LUMPER: "lumper",
} as const;

export const WARP_SOURCE_OWN_NETWORK = "WARP";

export const WARP_TRANSIT_CHARGE = "TRANSIT";

export const WARP_FAILURE_KIND = {
  RATE_LIMITED: "rate_limited",
  INVALID: "invalid",
  UNAVAILABLE: "unavailable",
} as const;

export const WARP_REQUEST_TIMEOUT_MS = 30_000;

// WHY: a Retry-After this short is a burst limit worth waiting out once; a longer one is the hourly or daily quota.
export const WARP_INLINE_RETRY_MAX_SECONDS = 5;

// WHY: Warp's staging quote calculator answered 500 for an LTL quote right after three bookings and quoted the same request on the next try.
export const WARP_SERVER_ERROR_RETRY_SECONDS = 2;

export const WARP_TRACKING_BATCH_LIMIT = 50;

export const WARP_FAILURE_MESSAGE_LIMIT = 500;
